import React from "react";
import Header from "./Components/Header";
import dashboardData from "./data/dashboardData.json";
import { CLASS_BOOKING } from "../../assets/asset";
import { Book, TrendingUp } from "lucide-react";
import SessionCard from "./Components/SessionCard";
import { useNavigate } from "react-router-dom";
import PageContainer from "./Components/PageContainer";
import MainContent from "./Components/MainContent";

const Dashboard = () => {
  const navigate = useNavigate();
  
  const headerProps = {
    heading: "Class Booking",
    subheading: "Book your next tutoring session",
    name: "Student",
    subject: "Mathematics"
  };

  const handleBookTutor = () => {
    navigate("/classBooking/bookTutor");
  };

  const handleMyBookings = () => {
    navigate("/classBooking/myBookings");
  };

  return (
    <PageContainer>
      <div className="sticky top-0 z-50 bg-[#DFF2EB]/70 backdrop-blur-md">
        <Header {...headerProps} />
      </div>

      <MainContent>
        <div className="flex items-center justify-between gap-10">
          <div className="flex-1">
            <h1 className="text-5xl font-bold text-gray-900">
              Need extra help?
            </h1>

            <p className="text-lg mt-4 text-gray-600 max-w-xl leading-relaxed">
              Browse qualified Australian maths tutors and book a personalised
              one-on-one session with an expert teacher.
            </p>

            <button 
              className="mt-6 px-10 py-3 bg-white shadow-md rounded-full font-semibold border border-gray-300 hover:shadow-lg transition"
              onClick={handleBookTutor}
            >
              Book a Tutor
            </button>
          </div>

          <div className="flex-1 flex justify-end">
            <img
              src={CLASS_BOOKING.heroImage}
              alt="Hero Illustration"
              className="w-[420px] h-auto object-contain"
            />
          </div>
        </div>

        <div className="mt-16 flex gap-10 w-full">
          <div className="flex-1 bg-white rounded-3xl shadow-md p-8 flex items-center gap-6 border border-gray-100">
            <div className="w-16 h-16 rounded-full bg-[#D7DDFF] flex items-center justify-center">
              <Book size={28} strokeWidth={2.4} className="text-[#001F8B]" />
            </div>

            <div className="flex flex-col">
              <p className="text-lg text-gray-700 font-medium">
                Upcoming sessions
              </p>
              <h2 className="text-4xl font-semibold text-gray-900">
                {dashboardData.stats.upcomingSessions}
              </h2>
            </div>
          </div>

          <div className="flex-1 bg-white rounded-3xl shadow-md p-8 flex items-center gap-6 border border-gray-100">
            <div className="w-16 h-16 rounded-full bg-[#E8FFE8] flex items-center justify-center">
              <TrendingUp
                size={28}
                strokeWidth={2.4}
                className="text-green-600"
              />
            </div>

            <div className="flex flex-col">
              <p className="text-lg text-gray-700 font-medium">
                Tutors worked with
              </p>
              <h2 className="text-4xl font-semibold text-gray-900">
                {dashboardData.stats.tutorsWorkedWith}
              </h2>
            </div>
          </div>
        </div>

        <div className="bg-transparent mt-16 p-10">
          <div className="flex justify-between items-center mb-10">
            <h3 className="text-2xl font-semibold text-gray-900">
              Upcoming Sessions ({dashboardData.stats.upcomingSessions})
            </h3>
            <button 
              className="text-blue-700 font-medium hover:underline"
              onClick={handleMyBookings}
            >
              See all my bookings
            </button>
          </div>

          <div className="flex flex-col gap-8">
            {dashboardData.sessions.map((session) => (
              <SessionCard key={session.id} session={session} />
            ))}
          </div>
        </div>
      </MainContent>
    </PageContainer>
  );
};

export default Dashboard;